<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hzyp9D/tc-custom/9781630476144.jpg?1705262992678" alt="This image is the cover for the book God's Business, Morgan James Faith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God's Business, Morgan James Faith
      </h1>
      <p class="bookDescription body article font2">
        <p>The conflict between staying true to your faith and staying true to your company is a constant battle for Christian business owners. The serenity you feel on Sunday soon goes away Monday morning when dealing with customers, vendors, and employees. So here’s the question: Can you have God in your life every day so that you can feel that joy constantly? YES! In God’s Business: How to Supercharge Your Faith, Your Profit, and Your Client Experience, Frederick “Coach” West III lays the foundation to enjoy more of your faith in your business.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frederick "Coach" West
      </h2>
      
      <p class="authorDescription body article">Frederick “Coach” West III is a “Higher Purpose Coach” who specializes in business coaching and consulting for Christian businesses. He received his coaching certification from the International Coach Academy in Melbourne, Australia. As the owner of Enterprise Solutions International and the founder of the Look Faith First Movement, he provides Christian businesses with the tools, clarity, and motivation to be profitable and fulfill God’s purpose for them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73b9cc1b